import { generateReport } from "../../../../../Api/reportApiService";

export const fetchReport = async ({
  filters,
  getPeriodLabel,
  selectedLevel,
  selectedReport,
  signal,
  texts,
  toast,
  t,
}) => {
  toast({
    title: t("reports.gatheringData", "جاري جمع البيانات من النظام..."),
    description: `${t("reports.fetchingData", "جاري جلب بيانات")} ${
      filters.periodFrom && filters.periodTo
        ? `${getPeriodLabel(filters.periodFrom)} → ${getPeriodLabel(filters.periodTo)}`
        : getPeriodLabel(filters.period)
    }`,
    status: "info",
    duration: 2000,
    isClosable: true,
  });

  const reportFilters = {
    ...filters,
    uploadedData: filters.uploadedData || null,
    uploadedFileName: filters.uploadedFileName || "",
  };

  const reportResponse = await generateReport(
    selectedLevel,
    selectedReport,
    reportFilters,
    texts?.en,
    { signal }
  );

  if (!reportResponse.success) {
    throw new Error(
      reportResponse.error ||
        t("reports.failedToFetchData", "فشل في جلب البيانات المالية")
    );
  }

  return reportResponse;
};
